// extracted by mini-css-extract-plugin
module.exports = {"root":"EABD2Button_root__2vX1Q"};